<template lang="pug">
  .container-recharge-apply.container-padding
    c-header
      h3(slot="left") 交易流水
    c-box
      el-form(:model="filters",label-position="right",label-width="125px")
        el-row(:gutter="1")
          el-col(:span="12")
            el-form-item(label="订单创建日期")
              el-date-picker(v-model="date", type="datetimerange", placeholder="选择时间范围")
          el-col(:span="12")
            el-form-item(label="交易完成日期")
              el-date-picker(v-model="date2", type="datetimerange", placeholder="选择时间范围")
        el-row(:gutter="1")
          el-col(:span="8")
            el-form-item(label="业务订单号")
              el-input(v-model="filters.out_trade_no")
            el-form-item(label="交易号")
              el-input(v-model="filters.trade_no")      
          el-col(:span="8")
            el-form-item(label="交易类型")
              el-select(v-model="filters.billType",style="width:280px;" clearable)
                el-option(:value="null", label="全部")
                el-option(v-for="n in 2", :key="n", :value="n", :label="n | billTypeStatus")
            el-form-item(label="交易状态")
              el-select(v-model="filters.pay_status" ,style="width:280px;" clearable)
                el-option(:value="null", label="全部")
                el-option(v-for="n in 7", :key="n", :value="n", :label="n | payStatusMap")
          el-col(:span="8")
            el-form-item(label="收款账号")
              el-select(v-model="filters.account_id" ,style="width:280px;" clearable)
                el-option(:value="null", label="全部")
                el-option(v-for="n in accountList", :key="n.account_id", :value="n.account_id", :label="n.desc")
        el-row(:gutter="1")
          el-col(:span="20")
            el-form-item(label="")
              el-button(@click="setFilter", type="primary") 搜索
              el-button(@click="timeReset") 重置时间
              el-button(@click="clearFilter", v-show="hasFilter") 清除
              el-button(@click="setDataFilter", type="primary") 导出
            //- el-form-item(label="")
              el-button(type="primary", @click="toAuditSelected(1)", :disabled="selectedItem.length <= 0") 确认选中项充值
              el-button(type="primary", @click="toAuditSelected(2)", :disabled="selectedItem.length <= 0") 驳回选中项充值
            //-   el-button(type="primary", @click="showOrder") 创建充值单
    c-box
      el-table(:data="list", fit, v-loading="listLoading", @selection-change="selectItem", size="small", border)
        el-table-column(property="create_time", label="交易创建时间", min-width="120", show-tooltip-when-overflow)
        el-table-column(label="交易类型", min-width="80", show-tooltip-when-overflow, v-slot="{ row }") {{ row.bill_type | billTypeStatus }}
        el-table-column(property="subject", label="商品标题", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="trade_no", label="交易号", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="out_trade_no", label="业务订单号", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="account_name", label="收款账户", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="trade_amount", label="金额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.trade_amount | toYuan }}
        el-table-column(property="fee_amount", label="平台手续费", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.fee_amount | toYuan }}
        el-table-column(property="receipt_amount", label="商家实收", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.receipt_amount | toYuan }}
        el-table-column(property="pay_status", label="交易状态", min-width="120", show-tooltip-when-overflow, v-slot="{ row }")
          span(v-if='row.bill_type===1') {{ row.pay_status | payStatusMap1 }}
          span(v-if='row.bill_type===2') {{ row.pay_status | payStatusMap2 }}
        el-table-column(property="success_time", label="交易完成时间", min-width="120", show-tooltip-when-overflow)
        el-table-column(property="comment", label="备注", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="outlay_account_name", label="操作", min-width="120", show-tooltip-when-overflow, v-slot="{ row }")
          el-button(type="primary", size="small", @click="showDetail(row)") 详情
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")
    el-dialog(title="订单详情", :visible.sync="detail.show", top="5%")
      el-form(:model="detail.source", label-position="right", label-width="150px")
        el-form-item(label="业务订单号") {{detailData.out_trade_no}}
        el-form-item(label="交易类型") {{detailData.bill_type | billTypeStatus}}
        el-form-item(label="交易号") {{detailData.trade_no}}
        el-form-item(label="订单创建时间") {{detailData.create_time}}
        el-form-item(label="交易成功时间") {{detailData.success_time}}
        el-form-item(label="交易状态",v-if='detailData.bill_type == 1') {{detailData.pay_status | payStatusMap1 }}
        el-form-item(label="交易状态",v-else) {{detailData.pay_status | payStatusMap2 }}
        el-form-item(label="支付方式") {{detailData.pay_channel | payChannelMap}}
        el-form-item(label="业务") {{detailData.app_name}}
        el-form-item(label="收款账户") {{detailData.account_name}}
        el-form-item(label="订单金额") {{detailData.trade_amount | toYuan }}
        el-form-item(label="平台手续费") {{detailData.fee_amount | toYuan }}
        el-form-item(label="商家实收") {{detailData.receipt_amount | toYuan }}
        el-form-item(label="商品标题") {{detailData.subject}}
        el-form-item(label="商品详情") {{detailData.body}}
        el-form-item(label="备注") {{detailData.comment}}
      .dialog-footer(slot="footer")
        el-button(@click="hideDetail()") 关闭
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      size: 10,
      list: [],
      total: 0,
      selectedItem: [],
      listLoading: false,
      order: {
        show: false,
        pic_url_array: []
      },
      filters: {
        billType: "",
        trade_no: "",
        out_trade_no: "",
        account_id: "",
        pay_status: "",
        trade_no: ""
      },
      date: [],
      date2: [],
      hasFilter: false,
      billList: [],
      detail: {
        show: false,
        source: {
          pic_array: []
        },
        log: []
      },
      detailData: {},
      accountList: []
    };
  },
  filters: {
    billTypeStatus(source) {
      switch (source) {
        case 1:
          return "支付";
        case 2:
          return "退款";
        default:
          return source;
      }
    },
    payStatusMap(source) {
      switch (source) {
        case 1:
          return "交易申请中";
        case 2:
          return "交易进行中";
        case 3:
          return "交易成功";
        case 4:
          return "交易关闭";
        case 5:
          return "交易完成";
        case 6:
          return "交易失败";
        case 7:
          return "交易异常，待退款";
        default:
          return source;
      }
    },
    payStatusMap1(source) {
      switch (source) {
        case 1:
          return "预下单";
        case 2:
          return "待付款";
        case 3:
          return "支付成功";
        case 4:
          return "交易关闭";
        case 5:
          return "交易完成";
        case 6:
          return "支付失败";
        case 7:
          return "交易异常，待退款";
        default:
          return source;
      }
    },
    payStatusMap2(source) {
      switch (source) {
        case 1:
          return "退款申请";
        case 2:
          return "退款中";
        case 3:
          return "退款成功";
        case 4:
          return "交易关闭";
        case 5:
          return "交易完成";
        case 6:
          return "退款失败";
        case 7:
          return "交易异常，待退款";
        default:
          return source;
      }
    },
    refundStatusMap(source) {
      switch (source) {
        case 1:
          return "退款进行中";
        case 2:
          return "退款成功";
        case 3:
          return "退款失败";
        case 4:
          return "退款撤消";
        // case 7:
        //   return "有退款";
        // case 8:
        //   return "无退款";
        default:
          return source;
      }
    },
    payChannelMap(source) {
      switch (source) {
        case "AliPay":
          return "支付宝";
        case "WeiXin":
          return "微信";
        case "UnionPay":
          return "银联";
        default:
          return source;
      }
    }
  },
  methods: {
    showDetail(row) {
      this.detail = {
        show: true
      };
      this.detailData = row;
      //   this.getDetailLog(row.id);
    },
    showOrder() {
      this.order.show = true;
    },
    hideDetail() {
      this.detail = {
        show: false,
        source: {
          pic_array: []
        },
        log: []
      };
    },
    getDetailLog(id) {
      return this.$store
        .dispatch("GET_RECHARGE_APPLY_LOG", id)
        .then(data => {
          if (this.detail.show) {
            this.detail.log = [...data];
          }
          return data;
        })
        .catch(({ msg }) => {
          this.$message({
            type: "error",
            message: `获取充值审批记录失败。${msg}`
          });
        });
    },

    toAuditOne({ id, audit_role_type }, status) {
      this.toAuditMultiple([id], status, audit_role_type);
    },
    toAuditSelected(status) {
      if (this.selectedItem.length === 0) {
        this.$message({
          type: "warning",
          message: `未选择任何审批条目`
        });
        return;
      }

      let id_array = [];
      let audit_role_type = null;
      let same_role_flag = true;
      this.selectedItem.forEach(v => {
        id_array.push(v.id);
        if (audit_role_type === null) {
          audit_role_type = v.audit_role_type;
        } else if (audit_role_type !== v.audit_role_type) {
          same_role_flag = false;
        }
      });
      if (same_role_flag) {
        this.toAuditMultiple(id_array, status, audit_role_type);
      } else {
        this.$message({
          type: "warning",
          message: `已选择的审批条目中包含当前审批角色与其他不一致的条目`
        });
      }
    },
    toAuditMultiple(id_array, status, audit_role_type) {
      if (status === 2) {
        this.$prompt("请输入驳回当前选中的充值申请原因", "驳回充值申请", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: "",
          inputPattern: /\S/,
          inputErrorMessage: `请输入原因`
        })
          .then(({ value }) => {
            this.toAudit(id_array, status, value, audit_role_type);
          })
          .catch(() => {});
      } else if (status === 1) {
        this.$confirm("是否确认通过当前选中的充值申请？", "确认充值申请", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.toAudit(id_array, status, "", audit_role_type);
          })
          .catch(() => {});
      }
    },
    toAudit(id_array, status, remark, audit_role_type) {
      const ids = JSON.stringify(id_array);
      const params = { ids, status, remark, audit_role_type };

      return this.$store
        .dispatch("AUDIT_RECHARGE_APPLY", params)
        .then(() => {
          this.$message({
            type: "success",
            message: `审批成功`
          });

          this.hideDetail();
          this.refresh();
        })
        .catch(({ msg }) => {
          this.$message({
            type: "error",
            message: `审批失败。${msg}`
          });
        });
    },
    timeReset() {
      this.date = [];
      this.date2 = [];
      this.refresh();
    },

    setFilter() {
      if (
        this.filters.status ||
        this.filters.id ||
        (Array.isArray(this.date) && this.date.length === 2) ||
        (Array.isArray(this.date2) && this.date2.length === 2)
      ) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    setDataFilter() {
      if (
        this.filters.status ||
        this.filters.id ||
        (Array.isArray(this.date) && this.date.length === 2) ||
        (Array.isArray(this.date2) && this.date2.length === 2)
      ) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.exportData(1);
    },
    clearFilter() {
      this.timeReset();
      this.filters = {
        id: null,
        status: null
      };
      this.hasFilter = false;
      this.getList(1);
    },
    getFilter() {
      let from_bill_date = null;
      let to_bill_date = null;
      let from_success_time = null;
      let to_success_time = null;

      const date = this.date;
      const date2 = this.date2;
      if (Array.isArray(date) && date.length === 2) {
        from_bill_date = this.$datetimeFormatter(date[0]);
        to_bill_date = this.$datetimeFormatter(date[1]);
      }
      if (Array.isArray(date2) && date2.length === 2) {
        from_success_time = this.$datetimeFormatter(date2[0]);
        to_success_time = this.$datetimeFormatter(date2[1]);
      }

      const filters = Object.assign({}, this.filters, {
        from_bill_date,
        to_bill_date,
        from_success_time,
        to_success_time
      });
      return filters;
    },

    refresh() {
      this.getList(this.page);
    },
    changeListSize(size = 10) {
      this.size = size;
      this.getList(1);
    },

    selectItem(val) {
      this.selectedItem = val;
    },

    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = this.getFilter();
      this.$store
        .dispatch(
          "LIST_USER_BILL",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          this.list = data.list;
          this.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    exportData(page = 1) {
      const _filters = this.getFilter();
      const params = Object.assign(
        {
          offset: this.size * (this.page - 1),
          limit: this.size,
          stat: true
        },
        _filters
      );
      let query = "?";
      for (const key in params) {
        if (params[key] !== "" && params[key] !== null) {
          query = query + key + "=" + params[key] + "&";
        }
      }
      window.open("./mch_web/v1/bill/export_user_bill" + query);
    },
    // 收款账户
    getAccountList(page = 1) {
      const _filters = Object.assign({}, this.filters);
      this.$store
        .dispatch(
          "GET_ACCOUNT_LIST",
          Object.assign({
            offset: 0,
            limit: 50,
            stat: false
          })
        )
        .then(data => {
          this.accountList = data.list;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  },
  mounted() {
    this.getList(1);
    this.getAccountList();
  }
};
</script>

<style lang="less">
.container-recharge-apply {
  .el-step.is-vertical .el-step__line {
    top: 8px;
    bottom: -8px;
  }
}
</style>
